import { AlpineComponent } from 'alpinejs';

type SeminarsEditFormData = {
  addNewTermin: (seminarId: string, e: Event) => void;
  duplicateTermin: (seminarId: string, e: Event) => void;
  removeTermin: (id: string, iterator: number, seminarId: string, e: Event) => void;
  seminarFormToggle: (e: Event) => void;
}

export default ():AlpineComponent<SeminarsEditFormData> => ({
  seminarFormToggle(e) {
    const target = e.currentTarget as HTMLElement;
    const section = target.closest('.article--intern-seminar') as HTMLElement;
    if (section) {
      section.classList.toggle('toggled');
    }
  },

  // Add new termin
  addNewTermin(seminarId, e) {
    const target = e.currentTarget as HTMLElement;
    if (target && target.parentElement) {
      target.classList.add('loading');

      let iterator = target.dataset.iterator;
      const terminContainer = target.parentElement.querySelector('.dates.subfields') as HTMLElement;
      if (terminContainer && iterator) {
        // Ajax request to addSeminarTermin() function
        const data = {
          action: 'add_seminar_termin',
          iterator: iterator,
          seminarId: seminarId,
        };
        fetch('/wp-admin/admin-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: new URLSearchParams(data).toString(),
        })
          .then(response => response.json())
          .then(response => {
            if (response.success) {
              terminContainer.innerHTML += response.data;

              target.classList.remove('loading');
            } else {
              console.error('Error:', response.data);
            }
          })
          .catch(error => console.error('Error:', error));

        // Increment iterator
        if (iterator) {
          target.dataset.iterator = (parseInt(iterator) + 1).toString();
        }
      }
    }
  },

  // Remove termin
  removeTermin(id, iterator, seminarId, e) {
    const target = e.currentTarget as HTMLElement;
    if (target) {
      target.classList.add('loading');

      // Set iterator
      const addBtn = document.getElementById(id) as HTMLElement;
      if (addBtn) {
        const currentIterator = addBtn.dataset.iterator;
        if (currentIterator) {
          addBtn.dataset.iterator = (parseInt(currentIterator) - 1).toString();
        }
      }

      // Remove data from DB
      if (iterator !== null && iterator !== undefined && seminarId != 'new') {
        console.log("Removing termin: " + iterator + ", Seminar: " + seminarId);
        const data = {
          action: 'remove_seminar_termin',
          iterator: iterator.toString(),
          seminarId: seminarId,
        };
        fetch('/wp-admin/admin-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: new URLSearchParams(data).toString(),
        })
          .then(response => response.json())
          .then(response => {
            if (response.success) {
              // Remove termin area
              const terminId = target.dataset.remove;
              if (terminId) {
                const dateGroup = document.querySelector(terminId) as HTMLElement;
                if (dateGroup) {
                  dateGroup.remove();
                }
              }

              target.classList.remove('loading');
              location.reload(); // Reload page to update seminar termins

              console.log(response.data);
            } else {
              console.error('Error:', response.data);
            }
          })
          .catch(error => console.error('Error:', error));
      } else {
        // Remove termin area
        const terminId = target.dataset.remove;
        if (terminId) {
          const dateGroup = document.querySelector(terminId) as HTMLElement;
          if (dateGroup) {
            dateGroup.remove();

            target.classList.remove('loading');
          }
        }
      }
    }
  },

  duplicateTermin(seminarId, e) {
    const target = e.currentTarget as HTMLElement;
    const seminarSection = document.getElementById('seminarform-new') as HTMLElement;
    const wrapper = seminarSection.querySelector('.wrapper--to-toggle') as HTMLElement;
    if (wrapper) {
      if (target) {
        target.classList.add('loading');
      }

      console.log("Duplicating seminar: " + seminarId);
      const data = {
        action: 'duplicate_seminar',
        seminarId: seminarId,
      };
      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams(data).toString(),
      })
        .then(response => response.json())
        .then(response => {
          if (response.success) {
            wrapper.innerHTML = ''; // Clear content of the seminar form
            wrapper.innerHTML = response.data;
            target.classList.remove('loading');

            console.log("Duplicating seminar: " + seminarId + " - Success");
          } else {
            console.error('Error:', response.data);
          }
        })
        .catch(error => console.error('Error:', error));
    }
  }
});
